






import { Vue, Component } from 'vue-property-decorator';
import { token, getWeChatSignature } from '@/api/api';
import wx from 'weixin-js-sdk';

@Component({
    name: 'app'
})

export default class App extends Vue {
    private mounted() {
        ((doc, win) => {
            const docEl = doc.documentElement;
            const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
            const recalc = () => {
                const clientWidth = docEl.clientWidth;
                if (!clientWidth) { return; }
                if (clientWidth >= 750) {
                    docEl.style.fontSize = '100px';
                } else {
                    docEl.style.fontSize =  `${100 * (clientWidth / 750)}px`;
                }
            };

            if (!doc.addEventListener) { return; }
            win.addEventListener(resizeEvt, recalc, false);
            doc.addEventListener('DOMContentLoaded', recalc, false);
        })(document, window);

        token().then((res: any) => {
            const token = res.data.token;
            localStorage.setItem('token', token);
        });

        const url = window.location.href.split('#')[0];
        getWeChatSignature({url}).then((res: any) => {
            // console.log(res);
            const data: any = res.data;
            wx.config({
                debug : false,
                appId : data.appId,
                timestamp : data.timestamp,
                nonceStr : data.nonceStr,
                signature : data.signature,
                jsApiList : ['getLocation']
            });
        });
    }

    /**
     * 获取url参数
     */
    private getQueryString(name: string): string {
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
        const r = decodeURI(window.location.search).substr(1).match(reg); // 匹配目标参数
        if (r !== null) return unescape(r[2]);
        return ''; // 返回参数值
    }
}
